<style lang="scss">
    .footer-logo {
        float: right;
        margin-top: 8px;
    }
</style>

<template>
    <img class="footer-logo" :src="src">
</template>

<script>
    import Bus from '../bus';

    export default {
        props: ['code'],
        data() {
            return {
                src: `${this.code}/images/footer_logo.png`
            };
        },
        created() {
            Bus.$on('refresh.logo', this.refreshImage);
        },
        methods: {
            refreshImage() {
                this.src = `${this.src}?refresh=${new Date().getTime()}`;
            }
        }
    };
</script>
